{
  "label.tokenBudget": "TOKEN BUDGET",
  "label.deadRules": "DEAD RULES",
  "label.structure": "STRUCTURE",
  "label.actionPlan": "ACTION PLAN",
  "label.fixSummary": "FIX SUMMARY",
  "label.systemPrompt": "System prompt",
  "label.rootFile": "Root file",
  "label.ruleFiles": "Rule files",
  "label.skillFiles": "Skill files",
  "label.subDirFiles": "Sub-dir files",
  "label.mcpServers": "MCP servers",
  "label.baselineTotal": "Baseline total",
  "label.available": "Available",
  "label.redundantByConfig": "Redundant (enforced by config)",
  "label.duplicates": "Duplicates",
  "label.contradictions": "Contradictions",
  "label.staleReferences": "Stale References",
  "label.refactoringOpportunities": "Refactoring Opportunities",
  "label.tool": "Tool:",
  "label.score": "Score:",

  "status.noBudgetIssues": "✓ No budget issues found",
  "status.noDeadRules": "✓ No dead rules found",
  "status.noStructuralIssues": "✓ No structural issues found",
  "status.noAutoFixable": "✓ No auto-fixable issues found",
  "status.perfectScore": "✓ Perfect score — no issues found",
  "status.fixedIssues": "✓ Fixed {{count}} issue{{s}} — run `git diff` to review changes",

  "error.unknownTool": "No agent instruction files found. Run this command in a project that uses Claude Code, Codex, or Cursor.",
  "error.missingRootFile": "Found {{tool}} configuration but no root instruction file.",
  "error.dirtyWorkingTree": "Working tree is dirty. Commit or stash your changes before running --fix, or use --force to skip this check.",

  "fix.removedDeadRules": "Removed {{count}} redundant rule{{s}}",
  "fix.removedStaleRefs": "Removed {{count}} stale reference{{s}}",
  "fix.removedDuplicates": "Removed {{count}} exact duplicate{{s}}",

  "summary.redundantRules": "{{count}} redundant rule{{s}}",
  "summary.duplicates": "{{count}} duplicate{{s}}",
  "summary.contradictions": "{{count}} contradiction{{s}}",
  "summary.staleRefs": "{{count}} stale ref{{s}}",
  "summary.refactoringSuggestions": "{{count}} refactoring suggestion{{s}}",
  "summary.found": "{{parts}} found",

  "tokens.measured": "{{count}} tokens",
  "tokens.estimated": "~{{count}} tokens (estimated)",

  "actionPlan.andMore": "… and {{count}} more",

  "severity.critical": "{{count}} critical",
  "severity.warnings": "{{count}} warning{{s}}",
  "severity.suggestions": "{{count}} suggestion{{s}}",

  "budget.rootFileCritical": "Root instruction file is {{lines}} lines — agent compliance drops significantly above 200 lines",
  "budget.rootFileWarning": "Root instruction file is {{lines}} lines (recommended: < 200)",
  "budget.mcpLargeServer": "MCP server '{{name}}' consumes ~{{tokens}} tokens",
  "budget.baselineHigh": "Baseline context consumption is {{pct}}% of window",

  "deadRule.configOverlap": "Rule \"{{rule}}\" is already enforced by {{config}}",
  "deadRule.exactDuplicate": "Exact duplicate of line {{otherLine}} in {{otherFile}}",
  "deadRule.nearDuplicate": "Very similar to line {{otherLine}} in {{otherFile}} ({{similarity}}% similar)",

  "structure.contradiction": "Contradicting rules: \"{{snippet}}\" ({{fileA}} line {{lineA}}) conflicts with line {{lineB}}.",
  "structure.staleRef": "Stale reference: \"{{path}}\" does not exist.",
  "structure.scopeHook": "Rule at line {{line}} could be a git hook: \"{{snippet}}\"",
  "structure.scopePathScoped": "Rule at line {{line}} references a specific path — consider a path-scoped rule file: \"{{snippet}}\"",

  "label.budget": "BUDGET",
  "label.findings": "FINDINGS",
  "label.topIssues": "TOP ISSUES",
  "label.category": "Category",

  "compact.budgetLine": "{{used}} / {{window}} tokens ({{pct}}%)",
  "compact.andMore": "… and {{count}} more (run instrlint <command> for details)",
  "compact.budget": "Budget",
  "compact.deadRules": "Dead rules",
  "compact.duplicates": "Duplicates",
  "compact.contradictions": "Contradictions",
  "compact.staleRefs": "Stale refs",
  "compact.structure": "Structure",

  "markdown.title": "instrlint Health Report — {{project}}",
  "markdown.scoreLine": "**Score: {{score}}/100 ({{grade}})** · Tool: `{{tool}}`",
  "markdown.summary": "## Summary",
  "markdown.severity": "Severity",
  "markdown.count": "Count",
  "markdown.critical": "🔴 Critical",
  "markdown.warning": "🟡 Warning",
  "markdown.info": "ℹ️ Info",
  "markdown.contradictions": "Contradictions",
  "markdown.staleReferences": "Stale References",
  "markdown.deadRules": "Dead Rules",
  "markdown.duplicateRules": "Duplicates",
  "markdown.budgetIssues": "Budget Issues",
  "markdown.refactoringOpportunities": "Refactoring Opportunities",
  "markdown.lineRef": "(line {{line}})",
  "markdown.budgetCategory": "Category",
  "markdown.budgetTokens": "Tokens",
  "markdown.actionPlan": "## Action Plan",
  "markdown.attribution": "*Generated by [instrlint](https://github.com/jed1978/instrlint)*",

  "ci.passed": "✓ instrlint passed  score={{score}} grade={{grade}}",
  "ci.failed": "✖ instrlint failed  score={{score}} grade={{grade}}",
  "ci.writtenTo": "→ written to {{file}}",

  "initCi.created": "✓ Created {{path}}",
  "initCi.alreadyExists": "{{path}} already exists. Use --force to overwrite.",

  "install.installed": "✓ Installed to {{path}}\n  → Restart Claude Code to activate /instrlint",
  "install.alreadyExists": "{{path}} already exists. Use --force to overwrite.",
  "install.unknownTarget": "Specify --claude-code or --codex",
  "install.outdatedTitle": "instrlint skill is outdated",
  "install.outdatedVersions": "installed: {{installed}} → current: {{current}}",
  "install.updateCmd": "npx instrlint install {{flag}} --force",
  "install.updatePrompt": "Update skill now?",

  "verification.confirmed": "LLM confirmed",
  "verification.uncertain": "LLM uncertain",
  "verification.filteredCount": "⊘ {{count}} false positive{{s}} filtered by LLM",

  "fix.manualActions": "MANUAL ACTIONS NEEDED",
  "fix.hookCreate": "Add to .claude/settings.json:",
  "fix.hookWarning": "⚠ Hook executes shell commands — review carefully before adding",
  "fix.pathScopedCreate": "Create {{path}}:",
  "fix.thenRemoveLine": "Then remove line {{line}} from {{file}}"
}
